import React from 'react';
import { AiNameGeneratorWidgetContentfulModel } from 'src/api/models/AiNameGeneratorWidget';
import InlineNameGenerator from 'src/molecules/Standard/InlineNameGeneratorArticle/InlineNameGenerator/InlineNameGenerator';
import AiNameGeneratorWidget from 'src/molecules/Standard/NameGenerator/AiNameGeneratorWidget/AiNameGeneratorWidget';

const AIGeneratorWidgetHandler = (props: AiNameGeneratorWidgetContentfulModel): JSX.Element => {
  if (props.generatorType === 'inline') {
    return (
      <InlineNameGenerator
        headline={props.title}
        subhead={props.generatorDescription}
        placeholder={props.inputPlaceholder}
        helperText={props.helperText}
        generatorMode={props.generatorMode}
        generatorSubject={props.generatorSubject}
        theme={props.theme || 'Default'}
      />
    );
  }

  return (
    <AiNameGeneratorWidget
      title={props.title}
      description={props.generatorDescription}
      inputPlaceholder={props.inputPlaceholder}
      helperText={props.helperText}
      theme={props.theme || 'Default'}
    />
  );
};

export default AIGeneratorWidgetHandler;
